import { render, staticRenderFns } from "./z_template.vue?vue&type=template&id=1dfc4e4c&"
import script from "./z_template.vue?vue&type=script&lang=js&"
export * from "./z_template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports